import routerOptions0 from "D:/word/qctsw-vue/node_modules/.pnpm/nuxt@3.10.1_@opentelemetry+api@1.8.0_@types+node@20.10.3_@unocss+reset@0.60.3_eslint@8.55.0_f_4qqb5mhawrn26h6ep63dhqv3te/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}